import { MailNotificationInterface } from '@/types/interfaces';
import axios from 'axios';
import firebase from 'firebase'

const databaseURL = process.env.VUE_APP_FIREBASE_CLOUD_FUNCTIONS;
export default {
  async getUser(uid) {
    try {
      const response = await axios.get(`${databaseURL}/getUser?id=${uid}.json`);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  },

  async updateVoters(data) {
    try {
      const response = await axios.put(`${databaseURL}/updateVoters`, data);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  },

  async addUser(data) {
    return await axios.put(`${databaseURL}/addUser`, { ...data });
  },

  async updateSection(data) {
    return await axios.put(`${databaseURL}/updateSection`, { ...data });
  },
  async updateDocument(data) {
    return await axios.put(`${databaseURL}/updateDocument`, { ...data });
  },
  async addSection(newSection) {
    return await axios.post(`${databaseURL}/addSection`, { ...newSection });
  },
  async addArgument(newArgument) {
    return await axios.post(`${databaseURL}/addArgument`, { ...newArgument });
  },
  async updateUserDocuments(data) {
    return await axios.put(`${databaseURL}/updateUserDocuments`, { ...data });
  },
  async updateUserNotifications(data) {
    return await axios.put(`${databaseURL}/updateUserNotifications`, { ...data });
  },
  async updateConsensus(data) {
    return await axios.put(`${databaseURL}/updateConsensus`, { ...data });
  },
  async sendNotifications(data: MailNotificationInterface) {
    return await axios.put(`${databaseURL}/sendNotifications`, { ...data });
  },
  async sendPushNotifications(data: MailNotificationInterface) {
    /**
     * Right now we're using FCM legacy API. See https://firebase.google.com/docs/cloud-messaging/migrate-v1
     * Also, there's probably a better way of sending batch notifications than iterating over a list of recipients.
     */
    for (const recipient of data.recipientsList) {
      const notificationData = {
        data: {
          title: data.title,
          body: data.body.content,
          link: data.body.url
        },
        to: recipient.toRegistrationToken
      }
      try {
        const result = await fetch('https://fcm.googleapis.com/fcm/send', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `key=${process.env.VUE_APP_CLOUD_MESSAGING_SERVER_KEY}`
          },
          body: JSON.stringify(notificationData),
        })
      } catch (e) {
        console.debug('notification error:', e)
      }
    }
  },
  /**
   * Sends an notification unsubscription request to the backend
   * @param token A jwt that includes encrypted unsubscription data
   * @returns {boolean} True if unsubscription succeeded or false otherwise
   */
  async unsubscribeUser(token: string): Promise<boolean> {
    try {
      const response = await axios.put(`${databaseURL}/unsubscribe`, { token });
      return response.status === 200;
    } catch (err) {
      return false;
    }
  }
};
